import RequiredAttribute from './RequiredAttribute';

export default RequiredAttribute;
